export const getInitials = (name: string | undefined): string | undefined => {
    return name?.match(/(^\S\S?|\b\S)?/g)?.join('')?.match(/(^\S|\S$)?/g)?.join('').toUpperCase();
}

export const isValidImage = (url: string): boolean => {
    return url.endsWith('.png') || url.endsWith('.jpeg') || url.endsWith('.jpg') || url.endsWith('.svg');
}